export enum LOCATION {
  JOB = 1,
  JOB_SEEKER = 2,
  APPLICANT = 3,
  EMPLOYER = 4,
}

export enum PROFILE_STEPS {
  STORE_CREATED = 1,
  DOCUMENT_UPLOADED = 2,
}

export enum OTP_TYPES {
  SIGNUP = 1,
  LOGIN = 2,
  FORGET = 4,
  UPDATE = 5,
}

export enum EXPORT_TYPE {
  PDF = "PDF",
  CSV = "CSV",
  EXCEL = "Excel",
}
export enum ROLE {
  ADMIN = 2,
  SUB_ADMIN = 3,
  USER = 1,
}
export const enum DOCUMENT_STATUS {
  PENDING = 1,
  ACCEPTED = 2,
  REJECTED = 3,
}
export enum DINING_OPTIONS {
  DELIVERY = 1,
  PICKUP = 2,
  DINEIN = 3,
}

export const DINING_TABS = {
  1: "Delivery",
  2: "Pickup",
  3: "Dine-In",
};

export const SUBCOMMUNITY_CONTENT_CATEGORY_TYPE = {
  TOPIC: 1,
  ANNOUNEMENT: 2,
};

// Orders
export enum ORDER_STATUS {
  ONGOING = 1,
  COMPLETED = 2,
}

export enum ORDER_TYPE {
  DELIVERY = 1,
  PICKUP = 2,
  DINE_IN = 3,
}

export enum PROMOTION_REWARD_TYPE {
  REWARDS = 1,
  PROMOTIONS = 2,
  ONLINE_BRANDS = 3,
}

export const REWARDSPROMOTIONS_TYPE = {
  REWARDS: 1,
  PROMOTIONS: 2,
  ONLINE_BRANDS: 3,
} as const;

export enum PROMOTION_TYPE {
  APP_ONLY = 1,
  IN_STORE = 2,
}

export enum REWARD_TYPE {
  DISCOUNT = 1,
  CASHBACK = 2,
}

export enum REWARD_CATEGORY {
  BOOKS = 1,
  UNIFORM = 2,
  STATIONARY = 3,
}

// Notifications
export const NOTIFICATION_SCHEDULE_TYPE = {
  NOW: 1,
  LATER: 2,
} as const;

export const NOTIFICATION_TYPE = {
  EMAIL: 1,
  PUSH: 2,
  SMS: 3,
} as const;

export enum NOTIFICATION_TEMPLATE_TYPE {
  NEW_USER_AEEDED = 1,
  SIGNUP_EMAIL_VERIFICATION = 2,
  LOGIN_EMAIL_VERIFICATION = 3,
  PROFILE_UPDATE_EMAIL_VERIFICATION = 4,
  FORGOT_EMAIL_VERIFICATION = 5,
  FORGOT_PASSWORD = 6,
  CHANGE_PASSWORD = 7,
  SYSTEM_EMAIL_TEMPLATE = 8,
  SUBADMIN_CREDENTIALS = 9,
  TEST_EMAIL = 100,
  TEST_PUSH = 101,
  BIRTHDAY_TEMPLATE = 10,
}

export enum USER_TYPE {
  APP = 1,
  ERP = 2,
}

export const ACTIVITY_MODULES = {
  USER: 1,
  REWARD: 2,
  PROMOTIONS: 3,
  STORE: 4,
  FEEDBACK: 5,
  SYSTEM_SETTINGS: 6,
  NOTIFICATION: 7,
  ACTIVITY_LOGS: 8,
  SUBADMIN: 9,
  CMS: 10,
  BRAND: 11,
  REWARD_AND_PROMOTION: 12,
} as const;

export const ACTIVITY_TYPES = {
  LOGIN: 1,
  APPLICATION_OPEN: 2,
  PROFILE_UPDATE: 3,
  NEW_REGISTRATION: 4,
  VIEW_ALL: 5,
  VIEW_SINGLE: 6,
  CREATE: 7,
  UPDATE: 8,
  DELETE: 9,
} as const;

export enum CUSTOMER_TYPE {
  LEAST_ACTIVE = "LEAST_ACTIVE",
  LEAST_INACTIVE = "LEAST_INACTIVE",
}

// module.exports = {
//   GENDER:{
//       DEFAULT:0,
//       MALE: 1,
//       FEMALE: 2,
//       OTHER: 3
//    },
//   SNS_TYPE: {
//       NORMAL : 1,
//       GOOGLE: 2,
//       FACEBOOK: 3
//   },
//   DEVICETYPE: {
//       WEB: "WEB",
//       ANDROID: "ANDROID",
//       IOS: "IOS",
//       DEFAULT:""
//   },
//   ENCRYPTION_DEV_TYPE:{
//       web:"web",
//       ios:"ios",
//       android:"android"
//   },
//   ROLE: {
//       USER:1,
//       ADMIN:2,
//       SUBADMIN:3
//   },

//   PANNEl_ROLES: {
//       ADMIN: 1,
//       SUBADMIN:2
//   },
//   PROJECT_USER_ROLES:{
//       USER: 1,
//       SUBADMIN: 2,
//       ADMIN: 3,
//       ALL: 4
//   },
//   USER_STATUS:{
//    NEW: 1,
//    ACTIVE: 2
//   },
//   VERIFICATION_TYPE: {
//       SIGNUP: 1,
//       LOGIN: 2,
//       PROFILE_UPDATE: 3,
//       FORGET: 4
//   },
//   APPROVE_STATUS: {
//       PENDING: 1,
//       APPROVED: 2,
//       REJECTED: 3
//   },
//   MODULES: {
//       DASHBOARD: 1,
//       USERS: 2,
//       SUBADMIN: 3,
//       ANALYTICS: 4,
//       SUPPORT: 5,
//       NOTIFICATION: 6,
//       CMS: 16,
//       SETTING: 17
//   },
//   GRAPH_TYPE: {
//       DAILY: 1,
//       WEEKLY: 2,
//       MONTHLY: 3,
//       YEARLY: 4
//   },
//   PUSH_TYPE_KEYS: {
//       DEFAULT: 0
//   },
//   PUSH_TYPE: {
//       0: {
//           keys: [],
//           message: {
//               en: "default."
//           },
//           title: {
//               en: "default"
//           }
//       }
//   },
//   NOTIFICATION_TYPE: {
//       SOCKET: 1,
//       PUSH: 2,
//       BROADCAST: 3,
//       BROADCAST_NEWS: 4,
//       MAIL: 4
//   },
//   DEFAULT_VALUE:{
//       APP:"hojDpQS4eMynfjGOUU7rl",
//       OTP_LENGTH:4
//   },
//   SIDEBAR_IDS: {
//       DASHBOARD: 1,
//       MANAGE_USERS: 2,
//       MANAGE_SUBADMIN: 3,
//       REPORTS: 4,
//       NOTIFICATION: 5,
//       CMS: 6
//   },
//   PAGINATION_LIMITS: {
//       SKIP: 1,
//       LIMIT: 10
//   },
//   NOTIFICATION_TEMPLATE_TYPE:{
//       NEW_USER_AEEDED:1,
//   },
//   NOTIFICATION_SENDER_TYPE:{
//       SYSTEM:1,
//   },
//    NOTIFICATION_TYPE:{
//       EMAIL: 1,
//       PUSH: 2,
//       SMS: 3
//   },
//   OTP_LENGTH: 6,
//   PROMOTION_TYPE:{
//       APP_ONLY:1,
//       IN_STORE:2
//   },
//   REWARD_TYPE:{
//       DISCOUNT:1,
//       CASHBACK:2
//   },
//   STORE_STATUS:{
//       OPEN:1,
//       CLOSED:2
//   }

// };
